import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { colorPrimary } from "../../constants/colors";
import Hint from "../../HOC/Hint/Hint";
import { IButtonIconProps } from "./ButtonIcon.props";
import styles from "./ButtonIcon.module.scss";

const ButtonIcon = ({ className, hint = "", hintPosition, icon, iconSize = "xl", iconColor = colorPrimary, ...props }: IButtonIconProps): JSX.Element => {
	return (
		<Hint hint={hint} position={hintPosition}>
			<button className={cn(styles.button, className)} type="button" {...props}>
				<FontAwesomeIcon icon={icon} size={iconSize} color={iconColor} />
			</button>
		</Hint>
	);
};

export default ButtonIcon;
